import { Md5 } from 'ts-md5';

export function Stringify<T>(args: T): string {
  return JSON.stringify(args);
}

export function GetValueFromObject(object: any, option: string): string {
  if (!option || typeof object !== 'object') {
    return object.toString();
  }

  if (option.endsWith('()')) {
    const functionName = option.slice(0, option.length - 2);

    return object[functionName]().toString();
  }

  const properties: string = option
    .replace(/\[(\w+)\]/g, '.$1')
    .replace(/^\./, '');
  const propertiesArray: string[] = properties.split('.');

  for (const property of propertiesArray) {
    if (property in object) {
      // eslint-disable-next-line
      object = object[property];
    }
  }
  if (!object) {
    return '';
  }

  return object.toString();
}

export function EncodeMD5(data: string): string {
  return Md5.hashStr(data)!;
}

export function Encode64(data: string): string {
  return btoa(utf8(data));
}

export function Decode64(data: string): string {
  return atob(data);
}

export function Parse(args: string): any {
  return args ? JSON.parse(args) : null;
}

export function DeepCopy<T>(args: T): T {
  return Parse(Stringify(args)) as T;
}

export const Upsert =
  <K, V>(CustomCheck: (item: V) => K) =>
  (itemToPush: V, collection: V[]) => {
    if (collection) {
      if (!CustomCheck(itemToPush)) {
        collection.push(itemToPush);
      } else {
        const collectionIndex = collection.findIndex(
          (element) => CustomCheck(itemToPush) === CustomCheck(element)
        );
        if (collectionIndex > -1) {
          collection[collectionIndex] = itemToPush;
        } else {
          collection.push(itemToPush);
        }
      }

      return collection;
    }
    return [];
  };

export function GetObjectValues(
  object: Object | Object[]
): Array<string | boolean | number> {
  if (object) {
    let values: Array<string | boolean | number> = [];
    const workingWithArray = object !== null && object instanceof Array;
    const workingWithObject = object !== null && typeof object === 'object';

    if (workingWithObject) {
      const test: any[] = Object.values(object);
      for (const iterator of test) {
        if (typeof iterator === 'boolean') {
          values.push(iterator);
        } else {
          const primitive =
            iterator === null ||
            (typeof iterator !== 'object' && typeof iterator !== 'function');
          if (primitive) {
            values.push(iterator);
          } else {
            for (const iterator of test) {
              values = [...values, ...GetObjectValues(iterator)];
            }
          }
        }
      }
    } else if (workingWithArray) {
      const array = object as Object[];
      for (const iterator of array) {
        values = [...values, ...GetObjectValues(iterator)];
      }
    }

    return values;
  }

  return [];
}

function utf8(str: string): string {
  const utf8Bytes = encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/g,
    (match, p1) => {
      return String.fromCharCode(parseInt('0x' + p1, 16));
    }
  );
  return utf8Bytes;
}

export function getValueUsingField(
  data: any,
  field: string,
  fieldContainsDots: boolean
): any {
  if (!field || !data) {
    return;
  }

  // if no '.', then it's not a deep value
  // if (!fieldContainsDots) {
  //     return data[field];
  // }

  // otherwise it is a deep value, so need to dig for it
  const fields = field.split('.');
  let currentObject = data;

  for (let i = 0; i < fields.length; i++) {
    if (currentObject === null) {
      return undefined;
    }
    currentObject = currentObject[fields[i]];
  }

  return currentObject;
}
